
















import { Component, Vue } from 'vue-property-decorator'
import LocationService from '@/services/LocationService'
import Country from '@/dto/deliveries/Country'
import CalculateStore from '@/stores/CalculateStore'

@Component({ inheritAttrs: false })
export default class ToCountrySelect extends Vue {
  countries: Country[] = []

  get country(): Country | null {
    return CalculateStore.country
  }

  set country(country: Country | null) {
    if (country) {
      CalculateStore.setCountry(country)
    }
  }

  filterCountries(query: string, update: Function) {
    LocationService.getCountries()
      .then(countries =>
        countries.filter(country =>
          country.name.toLowerCase().includes(query.toLowerCase())
        )
      )
      .then(countries => update(() => (this.countries = countries)))
  }
}
